if (!customElements.get('nsc-subscription-product')) {
  customElements.define(
    'nsc-subscription-product',
    class NscSubscriptionProduct extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-subscription-variants]').textContent);
        this.optionInputs = Array.from(this.querySelectorAll('[data-subscription-option]'));
        this.variantInput = this.querySelector('[data-subscription-variant-id]');
        this.sellingPlanInput = this.querySelector('[data-subscription-selling-plan]');
        this.submitButton = this.querySelector('[data-subscription-submit]');
        this.submitButtonText = this.submitButton?.querySelector('[data-subscription-submit-text]');
        this.price = this.querySelector('[data-subscription-price]');
        this.message = this.querySelector('[data-subscription-combination-message]');
        this.mainImage = this.querySelector('[data-subscription-main-image] img');
        this.thumbnails = Array.from(this.querySelectorAll('[data-subscription-thumbnail]'));

        this.optionInputs.forEach((input) => input.addEventListener('change', () => this.onOptionChange()));
        this.thumbnails.forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => this.activateMedia(thumbnail));
        });

        this.updateOptionAvailability();
      }

      get selectedOptions() {
        const selected = [];
        this.optionInputs.forEach((input) => {
          if (input.checked) selected[Number(input.dataset.optionPosition) - 1] = input.value;
        });
        return selected;
      }

      onOptionChange() {
        const options = this.selectedOptions;
        const variant = this.variants.find((candidate) =>
          candidate.options.every((option, index) => option === options[index])
        );

        this.updateOptionAvailability();

        if (!variant) {
          this.setUnavailable(this.dataset.combinationUnavailable);
          return;
        }

        this.variantInput.value = variant.id;
        this.price.textContent = variant.price;
        this.submitButtonText.textContent = `${this.dataset.submitPrefix} · ${variant.price}${this.dataset.priceSuffix}`;

        const purchasable = variant.available && variant.sellingPlanId;
        this.sellingPlanInput.value = variant.sellingPlanId || '';
        this.sellingPlanInput.disabled = !variant.sellingPlanId;
        this.variantInput.disabled = !purchasable;
        this.submitButton.disabled = !purchasable;
        this.submitButton.setAttribute('aria-disabled', String(!purchasable));
        this.message.hidden = purchasable;

        if (!purchasable) {
          this.message.textContent = variant.available ? this.dataset.planUnavailable : this.dataset.soldOut;
          this.submitButtonText.textContent = variant.available ? this.dataset.planUnavailable : this.dataset.soldOut;
        }

        if (variant.featuredMediaId) {
          const thumbnail = this.thumbnails.find(
            (candidate) => Number(candidate.dataset.mediaId) === variant.featuredMediaId
          );
          if (thumbnail) this.activateMedia(thumbnail);
        }

        if (!window.Shopify?.designMode) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }

      updateOptionAvailability() {
        const selected = this.selectedOptions;

        this.optionInputs.forEach((input) => {
          const candidateOptions = selected.slice();
          candidateOptions[Number(input.dataset.optionPosition) - 1] = input.value;
          const canPurchase = this.variants.some(
            (variant) =>
              variant.available &&
              variant.sellingPlanId &&
              variant.options.every((option, index) => option === candidateOptions[index])
          );
          input.disabled = !canPurchase && !input.checked;
        });
      }

      setUnavailable(message) {
        this.variantInput.disabled = true;
        this.sellingPlanInput.disabled = true;
        this.submitButton.disabled = true;
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButtonText.textContent = message;
        this.message.textContent = message;
        this.message.hidden = false;
      }

      activateMedia(thumbnail) {
        if (!this.mainImage || !thumbnail.dataset.imageUrl) return;

        this.mainImage.src = thumbnail.dataset.imageUrl;
        this.mainImage.removeAttribute('srcset');
        this.mainImage.alt = thumbnail.dataset.imageAlt || '';
        this.mainImage.width = Number(thumbnail.dataset.imageWidth);
        this.mainImage.height = Number(thumbnail.dataset.imageHeight);
        this.thumbnails.forEach((candidate) => candidate.setAttribute('aria-current', String(candidate === thumbnail)));
      }
    }
  );
}
